import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { WithApp } from 'contexts/appContext';
import { wsGetAll, wsFindBy } from 'services/WService';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import moment from 'moment';
import MultiComplete from 'components/Tvendo/Common/MultiComplete';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;
  const [incentivoData, setIncentivoData] = useState([]);
  // const incentivos = props.incentivos;

  const [dataImport, setDataImport] = useState({});
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState({
    ...customerPortfolioB,
    type: customerPortfolioB.type || 'N', // Por defecto N
  });
  const [providers, setProviders] = useState([]);
  const [categories, setCategories] = useState([]);
  const [lines, setLines] = useState([]);
  const [families, setFamilies] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedLines, setSelectedLines] = useState([]);
  const [selectedFamilies, setSelectedFamilies] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  
  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }
  async function listCategories() {
    let response = await wsFindBy('logi/category', { 
      deleted_at: 'null', state: 'A', base_business_partner_id: 1
    });
    if (response.success) {
      setCategories(response.data);
      setSelectedCategories([]);
    }
  }
  
  async function listLines(categoryIds = []) {
    if (categoryIds.length === 0) {
      setLines([]);
      setSelectedLines([]);
      return;
    }
  
    const response = await wsFindBy('logi/line', {
      deleted_at: 'null',
      state: 'A',
      'logi_category_id': categoryIds
    });
  
    if (response.success) {
      setLines(response.data);
      setSelectedLines([]);
    }
  }
  
  
  async function listFamilies(lineIds = []) {
    if (selectedLines.length === 0) {
      setFamilies([]);
      setSelectedFamilies([]);
      return;
    }
    
    let response = await wsFindBy('logi/family', {
      deleted_at: 'null', 
      state: 'A', 
      'logi_line_id': lineIds
    });
    
    if (response.success) {
      setFamilies(response.data);
      setSelectedFamilies([]);
    }
  }
  
  async function listProducts() {
    const familyIds = selectedFamilies.map(f => f.id);
    const lineIds = selectedLines.map(l => l.id);
    const categoryIds = selectedCategories.map(c => c.id);
  
    if (familyIds.length === 0 && lineIds.length === 0 && categoryIds.length === 0) {
      setProducts([]);
      setSelectedProducts([]);
      return;
    }
  
    const filters = {
      deleted_at: 'null',
      state: 'A',
    };
  
    if (familyIds.length > 0) {
      filters.logi_family_id = familyIds;
    } else if (lineIds.length > 0) {
      filters.logi_line_id = lineIds;
    } else if (categoryIds.length > 0) {
      filters.logi_category_id = categoryIds;
    }
  
    const response = await wsFindBy('logi/product', filters);
    if (response.success) {
      setProducts(response.data);
      setSelectedProducts(prev =>
        response.data.filter(p =>
          prev.some(sel => sel.id === p.id)
        )
      );
    }
  }

  useEffect(() => {
    if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) listCategories();
      setDataChanging(customerPortfolioB);
    }
  }, [customerPortfolioB.open]);

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map(item => ({ description: item.DESCRIPCION })),
        description: dataImport.nameFile
      });
    } else if (dataImport?.success === false) {
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.id) {
      setDataImport({});
    }
  }, [bPartnerSelect]);

  useEffect(() => {
    if (props.grupos_incentivos) {
      setIncentivoData([props.grupos_incentivos]);
      setDataChanging(prev => ({
        ...prev,
        unilever_grupo_id: props.grupos_incentivos.id,
      }));
    }
  }, [props.grupos_incentivos]);

  useEffect(() => {
    const categoryIds = selectedCategories.map(cat => cat.id);
  
    if (categoryIds.length > 0) {
      setDataChanging(prev => ({
        ...prev,
        logi_category_ids: categoryIds,
        logi_line_id: null,
        logi_family_id: null,
        logi_product_id: null,
      }));
      listLines(categoryIds);
      if (selectedCategories.length > 0) {
        listProducts(categoryIds);
      }
    } else {
      setDataChanging(prev => ({
        ...prev,
        logi_category_ids: [],
        logi_line_id: [],
        logi_family_id: [],
        logi_product_id: [],
      }));
      setLines([]);
      setSelectedLines([]);
      setProducts([]);
      // setSelectedProducts([]);
    }
  }, [selectedCategories]);

  useEffect(() => {
    const lineIds = selectedLines.map(lin => lin.id);
    const categoryIds = selectedCategories.map(cat => cat.id);
  
    if (lineIds.length > 0) {
      setDataChanging(prev => ({
        ...prev,
        logi_line_id: lineIds,
        logi_family_id: null,
        logi_product_id: null,
      }));
      listFamilies(lineIds);
      if (selectedLines.length > 0) {
        listProducts(lineIds);
      }
    } else {
      setDataChanging(prev => ({
        ...prev,
        logi_line_id: [],
        logi_family_id: [],
        logi_product_id: [],
      }));
      setFamilies([]);
      setSelectedFamilies([]);
      setProducts([]);
      if (categoryIds.length > 0) {
        listProducts(categoryIds);
      }
      // setSelectedProducts([]);
    }
  }, [selectedLines, selectedCategories]);

  useEffect(() => {
    const familyIds = selectedFamilies.map(fam => fam.id);
    const lineIds = selectedLines.map(lin => lin.id);

    if (familyIds.length > 0) {
      setDataChanging(prev => ({
        ...prev,
        logi_family_id: familyIds,
        logi_product_id: null,
      }));
      listProducts(familyIds);
    } else {
      setDataChanging(prev => ({
        ...prev,
        logi_family_id: [],
        logi_product_id: [],
      }));
      setProducts([]);
      setSelectedProducts([]);
      if (lineIds.length > 0) {
        listProducts(lineIds);
      }
    }
  }, [selectedFamilies, selectedLines]);

  useEffect(() => {
    const productIds = selectedProducts.map(product => product.id);
    if (productIds.length > 0) {
      setDataChanging(prev => ({
        ...prev,
        logi_product_ids: productIds,
      }));
    } else {
      setDataChanging(prev => ({
        ...prev,
        logi_product_ids: [],
      }));
    }
  }, [selectedProducts]);

  useEffect(() => {
    if (dataChanging.type === 'T') {
      setDataChanging(prev => ({
        ...prev,
        logi_category_id: null,
        logi_line_id: null,
        logi_family_id: null,
        logi_product_ids: null,
      }));
      setSelectedCategories([]);
      setSelectedLines([]);
      setSelectedFamilies([]);
      setSelectedProducts([]);
    }
  }, [dataChanging.type]);

  return (
    <>
      <Modal
        title={`Nuevo detalle de grupo de incentivo`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        grupos_incentivos={props.grupos_incentivos}
        arrDataResponse
        entity='sale/grupo-incentivo-detalle'
        dataForce={{
          id_cobertura: dataChanging.id_cobertura,
          type: dataChanging.type,
          unilever_grupo_id: dataChanging.unilever_grupo_id,
          logi_category_ids: selectedCategories.map(c => c.id),
          logi_line_ids: selectedLines.map(l => l.id),
          logi_family_ids: selectedFamilies.map(f => f.id),
          logi_product_ids: selectedProducts.map(p => p.id),
        }}
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <Autocomplete
          disableClearable
          options={incentivoData}
          getOptionLabel={(item) => `${item.description}`}
          renderInput={(params) => (
            <TextField {...params} label="Grupos incentivos" margin="normal" required />
          )}
          onChange={(e, item) => handleChange('unilever_grupo_id', item?.id)}
          value={incentivoData.find(incentivo => incentivo.id === dataChanging.unilever_grupo_id) || null}
          disabled
          required
        />
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Tipo</InputLabel>
          <Select
            required
            value={dataChanging.type}
            onChange={(e) => handleChange('type', e.target.value)} // Cambio aquí
          >
            <MenuItem value="T">Todos</MenuItem>
            <MenuItem value="N">Normal</MenuItem>
          </Select>
        </FormControl>
        <MultiComplete
          label="Categorías"
          selectAll
          limitTags={1}
          textField="description"
          options={categories}
          selected={selectedCategories}
          setSelected={setSelectedCategories}
          disabled={dataChanging.type === 'T'}
        />
        <MultiComplete
          label="Líneas"
          selectAll
          limitTags={1}
          textField="description"
          options={lines}
          selected={selectedLines}
          setSelected={setSelectedLines}
          disabled={dataChanging.type === 'T' || !lines.length}
        />
        <MultiComplete
          label="Familias"
          selectAll
          limitTags={1}
          textField="description"
          options={families}
          selected={selectedFamilies}
          setSelected={setSelectedFamilies}
          disabled={dataChanging.type === 'T' || !families.length}
        />

        <MultiComplete
          label="Productos"
          selectAll
          limitTags={1}
          textField="ItemName"
          options={products}
          selected={selectedProducts}
          setSelected={setSelectedProducts}
          disabled={dataChanging.type === 'T'}
        />
      </Modal>
    </>
  );
});
